<template lang="pug">
v-slide-y-transition(mode="out-in")
  v-container(fluid, v-if="!isLoading()")
    v-form(ref="accommodationForm", @submit="handleSubmit")
      v-card.mb2
        v-card-title
          h3.headline Datos generales
        v-card-text
          v-row
            v-col
              v-select(
                :label="$t('Tipo de alojamiento')",
                return-object,
                v-model="accommodation.accommodationType",
                :rules="validation.required",
                :items="accommodationTypes",
                required
              )

            v-col
              v-select(
                :label="$t('Estrellas')",
                return-object,
                v-model="accommodation.stars",
                :items="stars"
              )
                template(v-slot:item="{ item }")
                  div
                    v-icon(v-for="n in item", :key="n") star
                template(slot="selection", slot-scope="{ item }")
                  v-icon(v-for="n in item", :key="n") star

          v-text-field(
            :label="$t('Nombre')",
            v-model="accommodation.name",
            :rules="validation.required",
            required
          )

          v-checkbox(label="Visible", v-model="accommodation.visible")
          v-checkbox(label="Destacado", v-model="accommodation.featured")

          v-textarea(
            :label="$t('Descripción')",
            v-model="accommodation.description",
            :rules="validation.required",
            required
          )
          v-textarea(
            :label="$t('Notas')",
            v-model="accommodation.notes",
            required,
            hint="Políticas de cancelación / servicios del alojamiento..."
          )

        v-card-title
          h3.headline Datos de contacto

        v-card-text
          v-text-field(:label="$t('E-mail')", v-model="accommodation.email")
          v-text-field(:label="$t('Teléfono')", v-model="accommodation.phone")
          v-checkbox(
            label="Enviar notificaciones",
            v-model="accommodation.sendOwnerNotifications"
          )

        v-card-title
          h3.headline Precios

        v-card-text
          v-row
            v-col(xs12, sm6, md3)
              v-select(
                :label="$t('Tipo de precio')",
                return-object,
                v-model="accommodation.priceType",
                :rules="validation.required",
                :items="priceTypes",
                required
              )
            v-col(xs12, sm6, md3)
              v-text-field(
                :label="$t('Impuesto')",
                v-model="accommodation.tax",
                :rules="validation.required",
                required
              )
            v-col(xs12, sm6, md3)
              v-text-field(
                :label="$t('Comisión del agente')",
                v-model="accommodation.agentCommission",
                :rules="validation.required",
                required
              )
            v-col(xs12, sm6, md3)
              v-text-field(
                :label="$t('Comisión del alojamiento')",
                v-model="accommodation.accommodationCommission",
                :rules="validation.required",
                required
              )

        v-card-title
          h3.headline Ubicación

        v-card-text
          v-textarea(
            :label="$t('Localización')",
            v-model="accommodation.location",
            :rules="validation.required",
            required
          )

          v-text-field(
            :label="$t('Dirección')",
            v-model="accommodation.address",
            :rules="validation.required",
            required
          )

          v-row
            v-col(xs12, sm6, md4)
              v-text-field(
                :label="$t('Ciudad')",
                v-model="accommodation.town",
                :rules="validation.required",
                required
              )
            v-col(xs12, sm6, md3)
              v-text-field(
                :label="$t('Provincia')",
                v-model="accommodation.state",
                :rules="validation.required",
                required
              )
            v-col(xs12, sm4, md2)
              v-text-field(
                :label="$t('Código Postal')",
                v-model="accommodation.zip",
                :rules="validation.required",
                required
              )
            v-col(xs12, sm8, md3)
              v-autocomplete(
                :label="$t('Pais')",
                v-model="accommodation.country",
                :rules="validation.required",
                :items="countries",
                item-text="name",
                item-value="code",
                required
              )

          coordinates-picker(
            @change="handleCoordinatesChange",
            :geo-address="geoAddress",
            :o-lat="accommodation.lat",
            :o-lng="accommodation.lng"
          )

        v-card-actions
          v-btn(color="red", dark, @click="$router.push('/accommodations')") Cancelar
          v-spacer
          v-btn(color="primary", type="submit") Guardar

  v-container(fluid, fill-height, v-else)
    v-layout(flex, align-center, justify-center)
      v-progress-circular(
        indeterminate,
        color="primary",
        :size="128",
        :width="2"
      )
</template>

<script>
import CoordinatesPicker from "@/components/CoordinatesPicker";
import validation from "@/utils/validation";

const emptyAccommodation = {
  id: null,
  accommodationType: "",
  name: "",
  stars: 0,
  description: "",
  priceType: "",
  tax: 10,
  lat: null,
  lng: null,
  agentCommission: 0,
  accommodationCommission: 0,
  address: "",
  town: "",
  state: "",
  zip: "",
  country: "",
  visible: false,
  featured: false,
  showOwnerNotifications: false,
};

export default {
  components: {
    "coordinates-picker": CoordinatesPicker,
  },
  data() {
    return {
      priceTypes: [],
      accommodationTypes: [],
      accommodation: {},
      countries: [],
      stars: ["", 1, 2, 3, 4, 5],
      loading: {
        accommodation: false,
        accommodationTypes: false,
        priceTypes: false,
        countries: false,
        saving: false,
      },
      validation,
    };
  },
  computed: {
    geoAddress() {
      return [
        this.accommodation.address,
        this.accommodation.town,
        this.accommodation.zip,
        this.accommodation.state,
        this.accommodation.country,
      ]
        .filter((i) => !!i)
        .join(", ");
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    rand() {
      return Math.random().toString(36).substr(2, 9);
    },
    isLoading() {
      return (
        this.loading.accommodationTypes ||
        this.loading.priceTypes ||
        this.loading.countries ||
        this.loading.accommodation ||
        this.loading.saving
      );
    },
    fetchData() {
      this.loading.accommodation = true;
      this.loading.accommodationTypes = true;
      this.loading.priceTypes = true;
      this.loading.countries = true;

      if (this.$route.params.id) {
        api
          .get(`/accommodations/${this.$route.params.id}`)
          .then((res) => {
            this.accommodation = res.data;
          })
          .catch(this.handleError)
          .finally(() => {
            this.loading.accommodation = false;
          });
      } else {
        this.accommodation = Object.assign({}, emptyAccommodation);
        this.loading.accommodation = false;
      }

      api
        .get("/types/accommodations")
        .then((res) => {
          this.accommodationTypes = res.data;
        })
        .catch(this.handleError)
        .finally(() => {
          this.loading.accommodationTypes = false;
        });

      api
        .get("/types/prices")
        .then((res) => {
          this.priceTypes = res.data;
        })
        .catch(this.handleError)
        .finally(() => {
          this.loading.priceTypes = false;
        });

      api
        .get("/countries")
        .then((res) => {
          this.countries = res.data;
        })
        .catch(this.handleError)
        .finally(() => {
          this.loading.countries = false;
        });
    },
    handleCoordinatesChange(lat, lng) {
      this.accommodation.lat = lat;
      this.accommodation.lng = lng;
      // eslint-disable-next-line no-console
      console.log("updated");
      this.$forceUpdate();
    },
    handleSubmit() {
      if (this.$refs.accommodationForm.validate()) {
        this.loading.saving = true;
        if (this.accommodation.id === null) {
          api
            .post("/accommodations", this.accommodation)
            .then(() => {
              this.$router.push("/accommodations");
            })
            .catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
        } else {
          api
            .put(`/accommodations/${this.accommodation.id}`, this.accommodation)
            .then(() => {
              this.$router.push("/accommodations");
            })
            .catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
        }
      }
    },
    handleError(err) {
      // eslint-disable-next-line no-console
      console.error(err);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Accommodations/AccommodationForm.vue